import { useNavigate } from 'react-router-dom'
import { TableCell, TableRow, Checkbox, IconButton, Tooltip, Chip } from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import ShareIcon from '@mui/icons-material/Share'
import { useProject } from '../../context/ProjectContext'
import { formatDate } from '../../utils/formatDate'

const ProjectListItem = ({
  project,
  checkedProjects,
  handleCheckboxChange,
  handleOpenDeleteDialog,
  handleOpenShareSettings,
  monthlyUsage
}) => {
  const navigate = useNavigate()
  const { selectedProject, setSelectedProject } = useProject()

  const handleOpenProject = () => {
    setSelectedProject(project)
    navigate('/pages')
  }

  const handleOpenProjectSettings = () => {
    navigate(`/project/${project?.id}`)
  }

  const canDeleteProject = project?.is_owner && !project?.is_demo
  const canShareProject = Boolean(project?.is_owner)

  return (
    <TableRow
      key={project?.id}
      className='projectsTableBodyRow'
      hover
      onClick={handleOpenProject}
      sx={{ bgcolor: project?.id === selectedProject?.id ? 'rgba(69, 116, 210, 0.1)' : 'inherit' }}
    >
      <TableCell className='projectsTableBodyCheckboxCell' onClick={(e) => e.stopPropagation()}>
        {canDeleteProject && (
          <Checkbox
            className='projectsTableBodyCheckbox'
            checked={checkedProjects.includes(project?.id)}
            onChange={() => handleCheckboxChange(project?.id)}
          />
        )}
      </TableCell>
      <TableCell className='projectsTableBodyCell'>{project.name}</TableCell>
      <TableCell className='projectsTableBodyCell'>{project.url}</TableCell>
      <TableCell className='projectsTableBodyCell'>{project.owner || project.owner_user?.email || '-'}</TableCell>
      <TableCell className='projectsTableBodyCell'>
        {formatDate(project.created_at)}
      </TableCell>
      <TableCell className='projectsTableBodyCell' align='center'>
        <Chip
          label={monthlyUsage}
          size="small"
          sx={{
            fontWeight: 600,
            minWidth: '40px',
            backgroundColor: monthlyUsage > 0 ? 'rgba(69, 116, 210, 0.1)' : 'rgba(0, 0, 0, 0.06)',
            color: monthlyUsage > 0 ? '#4574D2' : '#757575',
          }}
        />
      </TableCell>
      <TableCell className='projectsTableBodyCell projectActionsCell' onClick={(e) => e.stopPropagation()}>
        <div className="projectActionsButtons">
          <Tooltip
            title="Project settings"
            PopperProps={{
              sx: {
                '& .MuiTooltip-tooltip': {
                  backgroundColor: 'primary.main'
                },
              },
            }}
          >
            <IconButton className="projectActionsIconButton" sx={{ p: 0 }} onClick={handleOpenProjectSettings}>
              <SettingsOutlinedIcon color='primary' />
            </IconButton>
          </Tooltip>
          {canShareProject && (
            <Tooltip
              title="Share project"
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'primary.main'
                  },
                },
              }}
            >
              <IconButton className="projectActionsIconButton" sx={{ p: 0 }} onClick={() => handleOpenShareSettings(project?.id)}>
                <ShareIcon color='primary' />
              </IconButton>
            </Tooltip>
          )}
          {canDeleteProject && (
            <Tooltip
              title="Delete project"
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'primary.main'
                  },
                },
              }}
            >
              <IconButton className="projectActionsIconButton" sx={{ p: 0 }} onClick={() => handleOpenDeleteDialog(project?.id)}>
                <DeleteOutlineOutlinedIcon color='error' />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </TableCell>
    </TableRow>
  )
}

export default ProjectListItem
